import React from 'react'
import Styles from "./FJCloudFailButton.module.less";
import InlineSVG from "react-inlinesvg";
import FJLocalStore from "../../../../store/FJLocalStore";
import warn from "../../../../icon/warn.svg";

function FJCloudFailButton(props) {
  const {onUpload, failedCount} = props;
  return (
    <div className={Styles.cloud_fail}>
      <InlineSVG src={warn} className={Styles.fail_icon}/>
      <div className={Styles.fail_desc}>
        {failedCount > 1 ? FJLocalStore._('files-failed-to-upload').replace('xxx', failedCount) : FJLocalStore._('file-failed-to-upload')}
        <span onClick={onUpload}>{FJLocalStore._('cloud-try-again')}</span>.
      </div>
    </div>
  );
}

export default FJCloudFailButton;